export default "__VITE_ASSET__dfa2bb4c__"